import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';

import getLoadsDetailPage from '~/modules/loadDetails/actions';
import {RowsHeader} from '~/components/search/results/LoadRow/';
import LoadRow from './Row';
import Spinner from '~/components/common/Spinner';
import css from './index.css';
import listcss from '~/components/search/results/results.css';

class SimilarLoads extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      showAll: false,
    }
    this.renderTable = this.renderTable.bind(this);
    this.showAllFunc = this.showAllFunc.bind(this);
  }
  componentDidMount(){
    this.props.getLoadsDetailPage();
  }
  render(){
    const { subTitle } = this.props;
    const title = (subTitle && subTitle.length) ?  subTitle : "Open Loads You May Like"
    return (
      <div className={cs(css.wrap, listcss.loadsGroup)}>
        <div className={css.marginStyle}></div>
        <div className={css.tit}>{title}</div>
        <div className={listcss.listContainer}>
          <div className={listcss.headerWrap}>
            <RowsHeader
              checkbox={false}
              isSimilar={false}
              checkedAll={false}
            />
          </div>
          <div className={css.bgColor}>
            {this.renderTable()}
          </div>
        </div>
        {this.props.topShow && <div className={css.marginStyle}></div>}
      </div>
    )
  }
  renderTable(){
    if(this.props.loading){
      return (
        <div className={cs(css.spinnerWrap, css.item1)}>
          <Spinner scalable={true}/>
        </div>
      )
    }
    if(this.props.error){
      return (
        <div className={cs(css.item1, css.red)}>error</div>
      )
    }
    if(this.props.lists && this.props.lists.length){
      let loads = this.props.lists.slice(0,20);
      const showAll1 = this.state.showAll;

      if(!showAll1 && loads.length > 5){
        loads = loads.slice(0,5);
      }

      return (
        <div className={css.loadWrap} onClick={this.showAllFunc}>
          {loads.map((i, index) => <LoadRow data={i} key={index}/>)}
          {!showAll1 && this.props.lists.length > 5 && (<div className={css.showAll}>See All<img className={css.icon} src='/assets/ic-more.svg'/></div>)}
        </div>
      )
    }
    return (
      <div className={css.item1}>No Data</div>
    )
  }
  showAllFunc(){
    this.setState({
      showAll: true
    })
  }
}

export default connect((state) => ({
  loading: state.detailsPageLoads.loading,
  error: state.detailsPageLoads.error,
  lists: state.detailsPageLoads.lists
}), mapDispatch({
  getLoadsDetailPage: (props) => getLoadsDetailPage(props.i),
}))(SimilarLoads);



// WEBPACK FOOTER //
// ./src/components/LoadPage/SimilarLoads/index.js